<template>
    <div
        ref="toastElm"
        class="text-gray-500 bg-white dark:bg-gray-500 dark:text-gray-200 rounded-lg shadow-md fixed bottom-20 right-12 hover:shadow-lg"
        :class="{ hidden: !toastVisible }"
        role="alert">
        <div class="relative px-4 pt-2 pb-4">
            <div class="font-normal">
                <div class="mb-1 font-semibold">
                    {{ $t('feedback.widget_heading') }}
                </div>
                <div
                    class="mt-2 font-normal flex gap-2 items-center justify-center">
                    <div
                        class="w-10 h-10 inline-flex justify-center items-center">
                        <img
                            src="/images/feedback/feedback-bad.svg"
                            class="w-10 h-10 opacity-75 opacity-100 cursor-pointer transition-transform hover:transform-[scale(1.32)] hover:duration-40 feedback-button"
                            @click="onFeedback('bad')"
                            :title="t('feedback.disapointed_title')" />
                    </div>
                    <div
                        class="w-12 h-12 inline-flex justify-center items-center">
                        <img
                            src="/images/feedback/feedback-could-be-better.svg"
                            class="w-10 h-10 opacity-75 opacity-100 cursor-pointer transition-transform hover:transform-[scale(1.32)] hover:duration-40 feedback-button"
                            @click="onFeedback('could-be-better')"
                            :title="t('feedback.neutral_title')" />
                    </div>
                    <div
                        class="w-12 h-12 inline-flex justify-center items-center">
                        <img
                            src="/images/feedback/feedback-good.svg"
                            class="w-10 h-10 opacity-75 opacity-100 cursor-pointer transition-transform hover:transform-[scale(1.32)] hover:duration-40 feedback-button"
                            @click="onFeedback('good')"
                            :title="t('feedback.happy_title')" />
                    </div>
                </div>
            </div>
            <button
                type="button"
                ref="closeButtonElm"
                class="absolute -top-4 -right-4 text-gray-400 hover:bg-gray-200 dark:text-gray-600 hover:text-gray-800 rounded-full text-sm w-8 h-8 inline-flex justify-center items-center bg-gray-100 shadow-sm dark:bg-gray-400 dark:hover:bg-gray-300 dark:hover:text-gray-900 cursor-pointer"
                @click="closeToast">
                <i-tabler-x class="w-6 h-6"></i-tabler-x>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { FeedbackType } from '~/helpers/types';

const { t } = useI18n();

const toastElm = ref<HTMLElement | null>(null);
const toastVisible = ref(false);
const emit = defineEmits(['select-feedback']);

const onFeedback = (feedback: FeedbackType) => {
    emit('select-feedback', feedback);
};

const closeToast = () => {
    toastVisible.value = false;
};

const openToast = () => {
    toastVisible.value = true;
};

const isVisible = () => {
    return toastVisible.value;
};

defineExpose({ close: closeToast, open: openToast, isVisible });
</script>

<style lang="scss" scoped>
.feedback-button {
    transition: transform 0.16s cubic-bezier(0.65, 0.61, 0.18, 1.8) 0.02s,
        filter 0.32s linear;
}
</style>
